export const optionItemFinder = (value, options) => {
    if (typeof options === 'object') {
        options = Object.keys(options).map(key => {
            return options[key];
        })
    }

    const normalizeOptions = options.reduce((options, item) => {
        return  item.options ? options.concat(item.options) : options.concat([item]);
    }, [])

    return  normalizeOptions.find(option => {
        return option.options ? option.options.find(subOption => subOption.value == value) : option.value == value
    });
}

export const cutRow = (row, length = 20) => {
    try {
        if (row.length > length)
            row = row.substring(0, length) + '...';

        return row;
    } catch (e) {
        console.log(e);
    }
};

export const filterOption = (options, input) => {
    const allOptions = [];

    options.map(option => {
        if (!('options' in option)) {
            if (option.label.toLowerCase().indexOf(input.toLowerCase()) !== -1) {
                allOptions.push(option);
            }
        }
        else {
            const filteredOptions = option.options.filter(o => o.label.toLowerCase().indexOf(input.toLowerCase()) !== -1);
            if (filteredOptions.length > 0) {
                allOptions.push({label: option.label, options: filteredOptions});
            }
        }
    });

    return allOptions;
};